import { render, staticRenderFns } from "./ReclamoExitoso.vue?vue&type=template&id=68fdb87c"
import script from "./ReclamoExitoso.vue?vue&type=script&lang=js"
export * from "./ReclamoExitoso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports